import DropdownMenu from '../util/dropdownMenu'
import AOS from 'aos';
import SplitHeader from "../util/splitHeader";
import TestimonialCarousel from "../util/testimonialCarousel";
import GalleryCarousel from "../util/galleryCarousel";
import GalleryFSCarousel from "../util/galleryFSCarousel";
import GalleryCarouselText from "../util/galleryCarouselText";
import PricingAccordion from "../util/pricingAccordion";
import RequestQuote from "../util/requestQuote";
import Map from '../util/map'
import ScrolltoAnchor from '../util/scrolltoAnchor.js'

export default {
    init() {
        // JavaScript to be fired on all pages
        const scrolltoAnchor = new ScrolltoAnchor();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        AOS.init();

        const dropDownMenu = new DropdownMenu();
        const splitHeader = new SplitHeader();
        const testimonialCarousel = new TestimonialCarousel();
        const galleryCarousel = new GalleryCarousel();
        const galleryFSCarousel = new GalleryFSCarousel();
        const galleryCarouselText = new GalleryCarouselText();
        const pricingAccordion = new PricingAccordion();
        const requestQuote = new RequestQuote();
        const map = new Map();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js